import React, { useLayoutEffect, useRef } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default function UtilisationAmStripChart({ data, darkMode = true }) {
  const chartRef = useRef(null);
  const prevLength = useRef(null);

  useLayoutEffect(() => {
    if (!chartRef.current) return;

    // ⚡ Only rebuild when bar count changes
    if (prevLength.current === data.length) return;

    prevLength.current = data.length;

    // --- Create chart ------------------------------------------------------
    const chart = am4core.create(chartRef.current, am4charts.XYChart);

    chart.data = data.map((value, index) => ({
      index,
      value
    }));

    chart.padding(0, 0, 0, 0);
	chart.height = am4core.percent(100);

    // --- Axes --------------------------------------------------------------
    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "index";
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.labels.template.disabled = true;

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 100;
    valueAxis.strictMinMax = true;
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.labels.template.disabled = true;
	valueAxis.renderer.baseGrid.strokeOpacity = 0.05;

    // --- Series ------------------------------------------------------------
    const series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = "value";
    series.dataFields.categoryX = "index";
    series.columns.template.width = am4core.percent(30);

    // ⭐ Premium gradient
	let gradient = new am4core.LinearGradient();

	gradient.addColor(am4core.color("#72d4f5"));
	gradient.addColor(am4core.color("#20afe8"));
	gradient.addColor(am4core.color("#087fb5"));

	series.columns.template.fill = gradient;
	series.columns.template.strokeOpacity = 0;
	series.columns.template.fillOpacity = 0.75;

    // ⭐ Apply fill
    series.columns.template.fill = gradient;
    series.columns.template.stroke = gradient;
    series.columns.template.strokeWidth = 0;
	series.columns.template.strokeOpacity = 0;
   

    // Optional: soften gradient stops for dark mode
    if (darkMode) {
      gradient.stops.each(stop => (stop.color.opacity = 0.7));
    } else {
      gradient.stops.each(stop => (stop.color.opacity = 1));
    }

    series.sequencedInterpolation = true;
    series.sequencedInterpolationDelay = 10;

    return () => chart.dispose();
  }, [data.length, darkMode]);

  return (
    <div
      ref={chartRef}
      style={{
        width: "100%",
        height: "120px"
      }}
    />
  );
}
